import React from 'react'
import Modal from './MyModal'
import MyButton from './buttons'
import { useTranslation } from 'react-i18next'

interface PhoneUsedModalProps {
  isOpen: boolean
  onClose: () => void
}

const PhoneUsedModal: React.FC<PhoneUsedModalProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation()

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div>
        <h2 className='text-xl font-bold mb-4'>{t('phone-used-title')}</h2>
        <p className='mb-6'>{t('phone-used-message')}</p>
        <div className='flex justify-end'>
          <MyButton onClick={onClose} variant='anthracite'>
            {t('close')}
          </MyButton>
        </div>
      </div>
    </Modal>
  )
}

export default PhoneUsedModal
